import { render, staticRenderFns } from "./IntegrationApp.vue?vue&type=template&id=8635e4b6&lang=pug&"
import script from "./IntegrationApp.vue?vue&type=script&lang=js&"
export * from "./IntegrationApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports